import { Navigate } from 'react-router-dom';

interface AtiraRouteProps {
  redirect: string;
}

export const AtiraRouteRedirct: React.FC<AtiraRouteProps> = ({ redirect }) => {
  return <Navigate to={redirect} replace />;
};
